import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';
import { getUserRole } from '../../utils/authUtils';
import { getRoleRank } from '../../constants/roles';

// Route-level version of the sidebar's minRank gate: 1=SuperAdmin ... 3=Owner, 4=View Only.
// The menu hiding an item is not access control, so a pasted URL must be refused here too
// (the API enforces the same rule on writes).
const RankRoute = ({ minRank, children }) => {
	const { state: authState } = useContext(AuthContext);

	// Wait for UserHydrator to populate the user before evaluating the role.
	if (!authState.user) return <div className="route-fallback" />;

	if (getRoleRank(getUserRole(authState.user)) > minRank) {
		return <Navigate to="/home" replace />;
	}
	return children;
};

RankRoute.propTypes = {
	minRank: PropTypes.number.isRequired,
	children: PropTypes.node.isRequired,
};

export default RankRoute;
